exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment_icons[data-v-035035b8] {\n  display: inline-block;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n@media screen and (max-width: 746px) {\n.payment_icons[data-v-035035b8] {\n    display: block;\n    float: none !important;\n    margin-left: 30px;\n}\n}", ""]);

// exports
